/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PendingRetailerConfirmationItemDto } from './PendingRetailerConfirmationItemDto';
import {
    PendingRetailerConfirmationItemDtoFromJSON,
    PendingRetailerConfirmationItemDtoFromJSONTyped,
    PendingRetailerConfirmationItemDtoToJSON,
} from './PendingRetailerConfirmationItemDto';

/**
 * 
 * @export
 * @interface PendingRetailerConfirmationsResponseDto
 */
export interface PendingRetailerConfirmationsResponseDto {
    /**
     * 
     * @type {Array<PendingRetailerConfirmationItemDto>}
     * @memberof PendingRetailerConfirmationsResponseDto
     */
    data: Array<PendingRetailerConfirmationItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationsResponseDto
     */
    queryCount: number;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationsResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationsResponseDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PendingRetailerConfirmationsResponseDto interface.
 */
export function instanceOfPendingRetailerConfirmationsResponseDto(value: object): value is PendingRetailerConfirmationsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('queryCount' in value) || value['queryCount'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PendingRetailerConfirmationsResponseDtoFromJSON(json: any): PendingRetailerConfirmationsResponseDto {
    return PendingRetailerConfirmationsResponseDtoFromJSONTyped(json, false);
}

export function PendingRetailerConfirmationsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingRetailerConfirmationsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PendingRetailerConfirmationItemDtoFromJSON)),
        'queryCount': json['queryCount'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}

export function PendingRetailerConfirmationsResponseDtoToJSON(value?: PendingRetailerConfirmationsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(PendingRetailerConfirmationItemDtoToJSON)),
        'queryCount': value['queryCount'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}

